import { useState, useRef } from "react";
import styles from "./../../sass/landing/hero.module.scss";
import classNames from "classnames";
import icon_exchange from "./../assets/icons/exchange.svg";
import login_icon from "./../assets/icons/login.png";
import { Link } from "react-router-dom";
import { ChevronRight, PlayCircleOutline, CloseCircleOutline } from "mdi-material-ui"; 
import video_mp4 from "./../assets/video/intro.mp4";
import video_webm from "./../assets/video/intro.webm";
import video_ogv from "./../assets/video/intro.ogv";
import SubscribeModal from "./SubscribeModal";
import { IconButton, Dialog, useMediaQuery, Link as MuiLink } from "@mui/material";
import { useTheme } from '@mui/material/styles';
import YouTube from 'react-youtube';

const Hero = () => {
  const [open, setOpen] = useState(false);
  const [video, setVideoOpen] = useState(false);
  const playerRef = useRef(null);
  const theme = useTheme();
  const isFullScreen = useMediaQuery(theme.breakpoints.down('md'));
  /*
  const handleInvestPaywall = () => {
    const isSubbed = localStorage.getItem("subbed");
    if(isSubbed) {
      window.open("https://www.investinbluesphere.com/");
    } else {
      setOpen(true);
    }
  }
  */
  const playVideo = () => {
    playerRef.current.internalPlayer.playVideo();
  };
  return (
    <>
      <div className={classNames(styles["hero-alt"])}>
        <div className={classNames(styles["tint"])}/>
        <div className={classNames(styles["video-background"])}>
          <video autoPlay loop muted playsInline className={classNames(styles["video"])}> 
            <source src={video_mp4} type="video/mp4" /> 
            <source src={video_webm} type="video/webm" />
            <source src={video_ogv} type="video/ogv" /> 
          </video>
        </div>
        <div className="container h-100">
          <div className="row h-100 align-items-center">
            <div className={classNames(styles["slogan"], "col-12")}>
              <h1 className={classNames(styles["line1"])}>
                The World's most Inclusive
              </h1>
              <h1 className={classNames(styles["line2"])}>
                Environmental Credit<br/> Economy and Community
              </h1>
              <IconButton
                className={classNames(styles["play-button"])}
                color="secondary"
                onClick={() => setVideoOpen(true)}
              >
                <PlayCircleOutline/>
              </IconButton>

              <div className="row mt-5">
                <div className="col-12 col-md-6 text-center d-flex justify-content-center justify-content-md-end mb-3 md-md-0">
                  <MuiLink 
                    href={"https://www.investinbluesphere.com/"}
                    target="_blank"
                    //onClick={() => handleInvestPaywall()}
                    style={{textDecoration:"none"}}
                    >
                    <button className="d-flex align-items-center">
                      <div className={classNames(styles["icon-holder"])}>
                        <img src={icon_exchange} alt="Invest Icon" />
                      </div>
                      <span>
                        Invest
                      </span>
                      <div
                        className={classNames(
                          styles["arrow-holder"],
                          "d-flex align-items-center justify-content-center"
                        )}
                      >
                        <ChevronRight/>
                      </div>
                    </button>
                  </MuiLink>
                </div>
                <div className="col-12 col-md-6 d-flex justify-content-center justify-content-md-start">
                  <Link 
                    to={"/app"}
                    style={{textDecoration:"none"}}
                    >
                    <button className="d-flex align-items-center">
                      <div className={classNames(styles["icon-holder"])}>
                        <img src={login_icon} alt="Login Icon" />
                      </div>
                      <span>
                        Enter App
                      </span>
                      <div
                        className={classNames(
                          styles["arrow-holder"],
                          "d-flex align-items-center justify-content-center"
                        )}
                      >
                        <ChevronRight/>
                      </div>
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <SubscribeModal
        isOpened={open}
        closeModal={() => setOpen(false)}
        successUrl="https://www.startengine.com/"
        submitButtonLabel="Invest Now"
      />
      <Dialog 
        fullScreen={isFullScreen}
        fullWidth={true}
        maxWidth="lg"
        open={video}
        onClose={() => setVideoOpen(false)}
        sx={{
          '& .MuiPaper-root': {
            backgroundImage: "linear-gradient(90deg, #8642fe 0%, #1b81f9 50%, #08f0bf 100%)",
          },
        }}                
      >

        <IconButton 
          className="d-block d-lg-none"
          size="large" 
          onClick={() => setVideoOpen(false)}
          style={{
            position: "absolute",
            top:0,
            right:0
          }}
          >
          <CloseCircleOutline
            style={{
              color: "#fff",
              fontSize:40
            }}
          />
        </IconButton>
   
        <div className={classNames(styles["fullscreen"],"d-flex align-items-center")}>
          <YouTube
            videoId="nUNdXBlX4Hk"
            opts={{
              playerVars: {
                autoplay: 1,
              },
            }}
            ref={playerRef}
            onReady={() => {
              playVideo();
            }}
          />  
        </div>
        {/*
        <iframe 
          width="100%" 
          height="100%" 
          src="https://www.youtube.com/embed/nUNdXBlX4Hk" 
          title="Welcome to Bluesphere Carbon" 
          frameBorder="0" 
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen/>
        */}
      </Dialog>
    </>
  );
};

export default Hero;
